/** @format */

export const html = [
  {
    title: 'Модуль 1',
    path: '/html/1',
    items: [
      { title: 'Введение', path: '/html/1/1' },
      { title: 'Теги и атрибуты', path: '/html/1/3' },
      { title: 'Обзор основных тегов', path: '/html/1/4' },
      { title: 'Блочные и строчные элементы', path: '/html/1/5' },
      { title: 'Абсолютные и относительные пути', path: '/html/1/6' },
      { title: 'Особенности графических форматов', path: '/html/1/7' },
      { title: 'Правила оформления кода', path: '/html/1/9' },
    ],
  },
  {
    title: 'Модуль 2',
    path: '/html/2',
    items: [
      { title: 'Технология CSS', path: '/html/2/1' },
      { title: 'Синтаксис CSS', path: '/html/2/2' },
      { title: 'Виды таблиц стилей', path: '/html/2/3' },
      { title: 'Виды селекторов', path: '/html/2/4' },
      { title: 'Группировка селекторов', path: '/html/2/5' },
      { title: 'Наследование, каскад, специфичность', path: '/html/2/6' },
      { title: 'Модель визуального форматирования', path: '/html/2/7' },
      { title: 'Блочные и строчные элементы', path: '/html/2/8' },
      { title: 'Особенности margin', path: '/html/2/9' },
      { title: 'Горизонтальное и вертикальное выравнивание', path: '/html/2/10' },
      { title: 'Оформление текста', path: '/html/2/11' },
      { title: 'Фон', path: '/html/2/12' },
    ],
  },
  {
    title: 'Модуль 3',
    path: '/html/3',
    items: [
      { title: 'Работа с цветом', path: '/html/3/1' },
      { title: 'CSS-градиент', path: '/html/3/2' },
      { title: 'CSS фильтры', path: '/html/3/3' },
      { title: 'Псевдоклассы и псевдоэлементы', path: '/html/3/4' },
    ],
  },
  {
    title: 'Модуль 4',
    path: '/html/4',
    items: [
      { title: 'Позиционирование элементов', path: '/html/4/1' },
      { title: 'Свойство z-index', path: '/html/4/2' },
      { title: 'Верстка выпадающего меню', path: '/html/4/3' },
      { title: 'Стандарт HTML5', path: '/html/4/4' },
    ],
  },
  {
    title: 'Модуль 5',
    path: '/html/5',
    items: [
      { title: 'Технология Flexbox', path: '/html/5/1' },
      { title: 'CSS-тени', path: '/html/5/2' },
      { title: 'CSS-трансформации', path: '/html/5/3' },
    ],
  },
  {
    title: 'Модуль 6',
    path: '/html/6',
    items: [
      { title: 'Работа со шрифтами', path: '/html/6/1' },
      { title: 'Абсолютные и относительные единицы CSS', path: '/html/6/2' },
      { title: 'Таблицы', path: '/html/6/3' },
      { title: 'Формы', path: '/html/6/4' },
    ],
  },
  {
    title: 'Модуль 7',
    path: '/html/7',
    items: [
      { title: 'Введение в Responsive веб дизайн', path: '/html/7/1' },
      { title: 'Правила responsive верстки', path: '/html/7/6' },
      { title: 'Медиазапросы', path: '/html/7/8' },
      { title: 'Mobile-first css', path: '/html/7/10' },
    ],
  },
]
